import { isDefined } from '@aloft/toolkit-shared';

import { CombinedColumn, SingleColumn, Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { getValueForColumn } from './getValueForColumn.ts';

export const hasNoStructuresButOtherCompsDo =
  (
    getColumns: (pathPrefix: string) => (SingleColumn<'feature' | 'adjustment'> | CombinedColumn)[],
    pathPrefixes: string[],
  ) =>
  (summary: Tkv2PairedCostSummaryInterfaceV2, compId = 'subject') => {
    if (compId === 'subject') {
      return false;
    }

    const columns = pathPrefixes.flatMap((prefix) => getColumns(prefix));
    const compsWithStructures = summary.compSequence.filter((cId) =>
      columns.some((col) => isDefined(getValueForColumn(summary, cId, col))),
    );

    return compsWithStructures.length > 0 && !compsWithStructures.includes(compId);
  };
